import { FORMATTER_DATA_TYPES } from '../../view/common/table/formatters/constants';
import ShortTextCell from '../../view/common/table/formatters/ShortTextCell';
import NumericCell from '../../view/common/table/formatters/NumericCell';
import HeaderFormatter from '../../view/common/table/formatters/HeaderFormatter';
import DateTimeCell from '../../view/common/table/formatters/DateTimeCell';
import TeamLogoCell from '../../view/common/table/formatters/TeamLogoCell';
import CurrencyCell from '../../view/common/table/formatters/CurrencyCell';
import BooleanCell from '../../view/common/table/formatters/BooleanCell';
import IconCell from '../../view/common/table/formatters/IconCell';
import AttribIconCell from '../../view/common/table/formatters/AttribIconCell';
import MultipleIconCell from '../../view/common/table/formatters/MultipleIconCell';

export class BaseTableTransformer {
    transformColumns(columns) {
        const transformedColumns = [];
        for (let i = 0; i < columns.length; i++) {
            const column = { ...columns[i] };
            if (column.data_field.endsWith('_id')) {
                continue;
            }

            let sortFunc = null;
            if (column.data_type === FORMATTER_DATA_TYPES.CURRENCY) {
                sortFunc = (a, b, order) => {
                    a = parseFloat(a);
                    b = parseFloat(b);
                    if (order === 'asc') {
                        return b - a;
                    }
                    return a - b;
                };
            }

            const transformedColumn = {
                formatter: this.columnFormatterMap(column.data_type),
                text: column.title,
                keyField: i + 'col',
                dataField: column.data_field,
                dataType: column.data_type,
                headerFormatter: HeaderFormatter,
                sort: column.sort || true,
                sortFunc: sortFunc,
                units: column.units
            };
            transformedColumns.push(transformedColumn);
        }
        return transformedColumns;
    }

    columnFormatterMap(type) {
        switch (type) {
            case FORMATTER_DATA_TYPES.INTEGER:
            case FORMATTER_DATA_TYPES.FLOAT:
                return NumericCell;
            case FORMATTER_DATA_TYPES.DATETIME:
                return DateTimeCell;
            case FORMATTER_DATA_TYPES.TEAM_LOGO:
                return TeamLogoCell;
            case FORMATTER_DATA_TYPES.CURRENCY:
                return CurrencyCell;
            case FORMATTER_DATA_TYPES.BOOLEAN:
                return BooleanCell;
            case FORMATTER_DATA_TYPES.ICON:
                return IconCell;
            case FORMATTER_DATA_TYPES.ICONS:
                return MultipleIconCell;
            case FORMATTER_DATA_TYPES.ATTRIB_ICON:
                return AttribIconCell;
            default:
                return ShortTextCell;
        }
    }

    transformRows(rows) {
        const transformedRows = [];
        for (let i = 0; i < rows.length; i++) {
            const row = { ...rows[i] };
            row.keyField = i + 'row';
            transformedRows.push(row);
        }
        return transformedRows;
    }

    transform(data) {
        if (!data) {
            return {};
        }

        if (data.isCombinedData) {
            return {
                title: data.title,
                columns: this.transformColumns(data.table.columns),
                rows: this.transformRows(data.table.rows)
            };
        }

        return {
            title: data.title,
            columns: this.transformColumns(data.columns),
            rows: this.transformRows(data.rows)
        };
    }
}
